import React, { useState } from "react";
import lapresMidiCover from "../../../albums/lapres-midi_cover.jpg";
import lapres_midi_anna_song2 from "../../../music/lapres-midi-anna-song2.mp3";
import lapres_midi_debussy_song1 from "../../../music/lapres-midi-debussy-song1.mp3";
import lapres_midi_sonate_song3 from "../../../music/lapres-midi-sonate-song3.mp3";
import PlayerCard from "../PlayerCard";

const LapresMidi = {
  cover: lapresMidiCover,
  songs: [
    {
      name: "Debussy: Prélude à l’après-midi d’un faune, L.86",
      subtitle: "Noémi Győri, Zoltán Fejérvári",
      mp3: lapres_midi_debussy_song1,
    },
    {
      name: "Anna T. Szabó: The Song of the Wood Nymphs",
      subtitle: "Noémi Győri, Kate Fleetwood",
      mp3: lapres_midi_anna_song2,
    },
    {
      name: "Mouquet: Sonate pour flûte et piano, Op.15 La Flûte de Pan — II. Pan et les oiseaux,",
      subtitle: "Noémi Győri, Zoltán Fejérvári",
      mp3: lapres_midi_sonate_song3,
    },
  ],
};

export const LapresMidiAlbum = () => {
  const [language, setLanguage] = useState({ eng: "true" }); // Replace with your language context

  return (
    <PlayerCard
      cover={LapresMidi.cover}
      songs={LapresMidi.songs}
	  buyLink={"https://lnk.to/NoemiGyori"}
	  bookletLink={"https://www.noemigyori.com/lapresmidi-booklet"}
      //buyLink="https://music.apple.com/us/album/lapr%C3%A8s-midi-dune-nymphe/1805883245"
      language={language}
	  listen={true}
    />
  );
};
